var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRef({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16.6666,
    cy: 16,
    r: 16,
    fill: "#1C6C2A"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.4666 23.4667H24.1333V21.8667C24.1333 20.3939 22.9394 19.2 21.4666 19.2M17.7333 11.7312C17.7333 13.4976 16.3008 14.9292 14.5333 14.9292C12.7658 14.9292 11.3333 13.4976 11.3333 11.7312C11.3333 9.96492 12.7658 8.53333 14.5333 8.53333C16.3008 8.53333 17.7333 9.96492 17.7333 11.7312ZM19.8666 23.4569H9.19995C9.19995 22.6996 9.19995 21.979 9.19995 21.3265C9.19995 19.5592 10.6326 18.1271 12.4 18.1271H16.6666C18.4339 18.1271 19.8666 19.5592 19.8666 21.3265C19.8666 21.979 19.8666 22.6996 19.8666 23.4569ZM20.9333 17.0667C19.7551 17.0667 18.8 16.1115 18.8 14.9333C18.8 13.7551 19.7551 12.8 20.9333 12.8C22.1115 12.8 23.0666 13.7551 23.0666 14.9333C23.0666 16.1115 22.1115 17.0667 20.9333 17.0667Z",
    stroke: "white",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRef);
export default __webpack_public_path__ + "static/media/ref.2f9d6feeaacb9282ba8642df1c42b9bd.svg";
export { ForwardRef as ReactComponent };